import {
  Badge,
  CountryCode,
  FlagComponent,
  Icons,
  Tooltip,
} from '@commenda/kakashi';
import { Country } from '@commenda/prisma';
import { IBusinessEntity } from '@commenda/types';
import { classNames, getPrintableCorporationType } from '@commenda/utils';
import { Country as CountryPkg } from 'country-state-city';

type TBusinessEntityCardOptions = {
  isRounded?: boolean;
  hideCountryFlag?: boolean;
  hideBorder?: boolean;
  hideTooltip?: boolean;
};

type TBusinessEntityCardProps = {
  businessEntity: IBusinessEntity;
  onEdit: (businessEntity: IBusinessEntity) => void;
  onDelete: (businessEntity: IBusinessEntity) => void;
  options?: TBusinessEntityCardOptions;
};

const BusinessEntityCard = ({
  businessEntity,
  onEdit,
  onDelete,
  options = {
    isRounded: true,
    hideCountryFlag: false,
    hideBorder: false,
    hideTooltip: false,
  },
}: TBusinessEntityCardProps) => {
  return (
    <div
      className={classNames(
        'rounded-xl bg-bg-primary p-xl flex justify-between items-center',
        options.isRounded ? 'rounded-xl' : '',
        !options.hideBorder ? 'border border-border-primary' : 'border-none'
      )}
    >
      <div className="flex items-center gap-2">
        {!options.hideCountryFlag && (
          <FlagComponent
            country={
              businessEntity.generalCorporationInfo
                .incorporationCountry as CountryCode
            }
            countryName={
              CountryPkg.getCountryByCode(
                businessEntity.generalCorporationInfo.incorporationCountry
              )?.name ||
              businessEntity.generalCorporationInfo.incorporationCountry
            }
          />
        )}
        <span className="txt-small-medium text-text-primary">
          {businessEntity.generalCorporationInfo.legalName}
        </span>
        <Badge size="sm" variant="gray">
          {getPrintableCorporationType(
            businessEntity.generalCorporationInfo.businessEntityType,
            businessEntity.generalCorporationInfo
              .incorporationCountry as Country
          )}
        </Badge>
      </div>
      {options.hideTooltip ? (
        <div className="flex items-center gap-3">
          <Icons.Edit02
            className="size-4 text-fg-quaternary hover:text-fg-quaternary-hover cursor-pointer"
            onClick={() => onEdit(businessEntity)}
          />

          <Icons.Trash01
            className="size-4 text-fg-quaternary hover:text-fg-error cursor-pointer"
            onClick={() => onDelete(businessEntity)}
          />
        </div>
      ) : (
        <div className="flex items-center gap-3">
          <Tooltip
            content="Edit entity details"
            side="bottom"
            disabled={options.hideTooltip}
          >
            <Icons.Edit02
              className="size-4 text-fg-quaternary hover:text-fg-quaternary-hover cursor-pointer"
              onClick={() => onEdit(businessEntity)}
            />
          </Tooltip>
          <Tooltip
            content="Delete entity"
            side="bottom"
            disabled={options.hideTooltip}
          >
            <Icons.Trash01
              className="size-4 text-fg-quaternary hover:text-fg-error cursor-pointer"
              onClick={() => onDelete(businessEntity)}
            />
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export { BusinessEntityCard };
